import type { GetServerSidePropsContext } from 'next';
import { AxiosError } from 'axios';

import { httpClient } from '@internal/api/system';
import { extractToken } from '@internal/api/system/utils';
import { Profile } from '@internal/types/profile';

export interface ServerProfileResult {
  profile: Profile | null;
  unauthorized: boolean;
}

export const getServerProfileResult = async (
  context: GetServerSidePropsContext
): Promise<ServerProfileResult> => {
  const token = extractToken(context);
  if (!token) return { profile: null, unauthorized: false };

  try {
    const { data } = await httpClient.fetch<Profile>({
      server: true,
      url: `${process.env.CRM_URL as string}/api-candidates/me`,
      method: 'GET',
      headers: { token },
      timeout: 10000,
    });

    return { profile: data ?? null, unauthorized: false };
  } catch (error) {
    return {
      profile: null,
      unauthorized: (error as AxiosError).response?.status === 401,
    };
  }
};

export const getServerProfile = async (
  context: GetServerSidePropsContext
): Promise<Profile | null> => (await getServerProfileResult(context)).profile;
